export default "__VITE_ASSET__SmQeJB90__"